import { testimonials } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './Testimonials.css';

export function Testimonials() {
  return (
    <Section
      id="testimonios"
      title={testimonials.title}
      lead={testimonials.lead}
      className="testimonials-section"
    >
      <div className="testimonials-grid">
        {testimonials.items.map((item, i) => (
          <ScrollReveal key={item.industry} delay={i * 80}>
            <article className="testimonial-card glass-card">
              <header className="testimonial-card__header">
                <div className="testimonial-card__avatar" aria-hidden="true">
                  {item.industry.slice(0, 1)}
                </div>
                <div>
                  <strong>{item.industry}</strong>
                  <span>{item.role}</span>
                </div>
              </header>
              <blockquote className="testimonial-card__quote">"{item.quote}"</blockquote>
              <div className="testimonial-card__metrics">
                {item.metrics.map((metric) => (
                  <span key={metric}>{metric}</span>
                ))}
              </div>
            </article>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
